import styled, { css } from 'styled-components/macro';
import {
  filtersToggleHeight,
  filtersToggleWidth,
} from '../../../utils/css/sizes';
import { colorBackground, colorLightYellow } from '../../../utils/css/colors';
import { filtersHeight } from '../../../utils/css/sizes';
import { bodyFont } from '../../../utils/css/fonts';
import { mobile } from '../../../utils/css/media';

export const Container = styled.div<{ isOpen: boolean, isHidden: boolean }>`
	background-color: ${colorBackground};
	position: relative;
	z-index: 2;
  pointer-events: none;
  background: transparent;
  transform: ${props => (props.isOpen ? 'translateY(0) ' : 'translateY(-100%)')};
	transition: transform 0.5s ease-in;
	will-change: auto;
	@media (max-width: 1450px)  {
    position: absolute;
    width: 100vw;
    ::-webkit-scrollbar { 
      display: none; 
    }
    overflow:auto;
    pointer-events: auto;
	}
`;

export const Content = styled.div`
	height: 86px;
	width: 100%;
	position: relative;
  pointer-events: auto;
  display: flex;
  align-items: center;
  padding-inline-start: 7%;
  @media (max-width: 1450px)  {
    height: unset;
    padding: 20px;
	}
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 1200px) {
    justify-content: flex-start;
  }
`;
export const ClearButton= styled.div`
font-family: ${bodyFont};
font-size: 18px;
line-height: 20px;
text-align: center;
display: flex;
align-items: center;
margin-inline-start: 12px;
margin-inline-end: 30px;
text-decoration-line: underline;
text-underline-offset: 3px;
  @media (max-width: 780px) {
   
  }
  @media (max-width: 1450px) {
    align-items: flex-start;
  }
`;
export const SelectItems = styled.div`
  display: flex;
`;

export const SearchSection = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 1450px) {
    align-items: flex-start;
  }
`;

export const ClearFilters = styled.div`
  cursor: pointer;
  text-decoration-line: underline;
  margin-top: 1.5rem;
  text-align: left;
`;

export const Toggle = styled.div`
  background-color: ${colorLightYellow};
  height: ${filtersToggleHeight}px;
  width: ${filtersToggleWidth}px;
  position: absolute;
  bottom: -${filtersToggleHeight / 4}px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  box-shadow: 0px 8px 3px -6px rgba(0, 0, 0, 0.25);
`;

export const IconContainer = styled.div`
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
`;

export const Icon = styled.img<{ isOpen: boolean }>`
  transform: rotate(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
  transition: 0.3s;
`;

export const CheckBoxsContainer = styled.div`
  display: flex;
  align-items: center;
`;
